import React from 'react'

import { FluentFlexContext } from './Context'
import { defaultClassName } from './Context/constants'

export interface RootProps {
  children?: React.ReactNode
  itemClassName?: string
}

const Root: React.FC<RootProps> = (props) => {
  const { itemClassName, children } = props

  const value = React.useMemo(() => {
    return {
      itemClassName: itemClassName || defaultClassName,
    }
  }, [itemClassName])

  return (
    <FluentFlexContext.Provider value={value}>
      {children}
    </FluentFlexContext.Provider>
  )
}

export default Root
